<template>
    <common-el-form :model="formModel" :submitData="submitData" @success="onSuccess" :SubmitButton="formModel.tatMemRewards.length>0"
                    @cancel="onCancel" submit-btn-text="保存" failTitle="提交失败" loadingText="提交中..."
                    :submitService="submitService" :showButton="false" labelWidth="110px" ref="formModel">
        <!--<p class="commonTitle">奖励配置</p>-->
        <el-form-item label="领袖新星补贴" prop="status">
            <el-switch
                v-model="formModel.status"
                active-value="1"
                inactive-value="0">
            </el-switch>
        </el-form-item>
        <p class="commonTitle">领袖新星补贴阶梯设置</p>
        <el-form-item>
            <div class="flex-col vertical-start up-level-box">
                <el-button type="primary" size="small" @click="addLevelItem" style="margin-bottom: 20px">
                    添加补贴阶梯
                </el-button>
                <div class="tatMemRewards flex-col vertical-start flow-justify">
                    <div class="flex-row vertical-center up-people-list"
                         :class="{'pad-right':formModel.tatMemRewards.length == 1}"
                         v-for="(item, index) in formModel.tatMemRewards" :key="index"
                         style="margin-bottom: 30px">
                        <el-form-item :prop="'tatMemRewards.' + index + '.startIndex'"
                                      :rules="startIndexRules" class="commonMargin">
                            <el-input-number placeholder="请输入分润金额" :controls="false"
                                             v-model="item.startIndex" controls-position="right"
                                             :min="0" :max="999999" :precision="0"
                                             :step="1" style="width:100px;"></el-input-number>
                        </el-form-item>
                        <p class="commonMargin">——</p>
                        <el-form-item :prop="'tatMemRewards.' + index + '.endIndex'"
                                      :rules="endIndexRules" class="commonMargin">
                            <el-input-number placeholder="请输入分润金额" :controls="false"
                                             v-model="item.endIndex" controls-position="right"
                                             :min="0" :max="999999" :precision="0"
                                             :step="1" style="width:100px;"></el-input-number>
                        </el-form-item>
                        <el-form-item :prop="'tatMemRewards.' + index + '.rewardsAmount'"
                                      :rules="rewardsAmountRules">
                            <el-input-number placeholder="请输入补贴金额" :controls="false"
                                             v-model="item.rewardsAmount" controls-position="right"
                                             :min="0" :max="999999" :precision="2"
                                             :step="0.1" class="commonMargin"></el-input-number>
                            <p class="commonMargin">元</p>
                        </el-form-item>
                        <el-button @click.prevent="removeLevelItem(item)"
                                   v-if="index>0">
                            删除
                        </el-button>
                    </div>
                </div>
            </div>
        </el-form-item>
    </common-el-form>
</template>

<script>
    import CommonElForm from 'components/common/CommonElForm'
    import Regs from "common/conf/Regs";
    import TatMemRewardsService from 'service/TatMemRewardsService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, validatorsMixin} from "mixin";
    import StorageService from 'store/interfaces';
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "AddOrganManage",
        props: {
            organInfo: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                startIndexRules: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        const Index = rule.field.replace(/[^0-9]/ig, "");
                        const currentendIndex = this.formModel.tatMemRewards[Index].endIndex;
                        if (!value) {
                            return callback(new Error('请设置用户起始排名'))
                        }
                        if (currentendIndex && value > currentendIndex) {
                            return callback(new Error('用户起始排名应小于终止排名'))
                        }
                        if (Index>0 && value <= this.formModel.tatMemRewards[Index-1].endIndex ){
                            return callback(new Error('起始排名应大于上一阶梯的终止排名'))
                        }
                        return callback()
                    },
                    trigger: ['blur', 'change']
                }],
                endIndexRules: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        const Index = Number(rule.field.replace(/[^0-9]/ig, ""));
                        const currentstartIndex = this.formModel.tatMemRewards[Index].startIndex;
                        if (!value) {
                            return callback(new Error('请设置用户终止排名'))
                        }
                        if (value < currentstartIndex) {
                            return callback(new Error('用户起终止名应大于起始排名'))
                        }

                        if (Index < this.formModel.tatMemRewards.length-1 && value >= this.formModel.tatMemRewards[Index+1].startIndex){
                            return callback(new Error('终止排名应小于下一阶梯的起始排名'))
                        }
                        return callback()
                    },
                    trigger: ['blur', 'change']
                }],
                rewardsAmountRules: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            return callback(new Error('请输入补贴金额'))
                        } else {
                            return callback()
                        }
                    },
                    trigger: ['blur', 'change']
                }],
                formModel: {
                    status: '0',
                    tatMemRewards: []
                },
                count:0,
                submitService: TatMemRewardsService.tatMemRewardsAdd
            }
        },
        mixins: [loadMixin, validatorsMixin],
        components: {
            CommonElForm
        },
        computed: {
            submitData() {
                const params = {
                    simpleTatId: this.organInfo.id,
                    status: this.formModel.status,
                    tatMemRewards: JSON.stringify(this.formModel.tatMemRewards)
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted() {
            this.getInfo();
        },
        methods: {
            onSuccess(res) {
                this.$emit('onSuccess', res)
                this.getInfo();
            },
            onCancel() {
                this.$emit('onCancel')
            },
            getInfo() {
                this.doLoad(TatMemRewardsService.tatMemRewardsDetail, {
                    simpleTatId: this.organInfo.id,
                    userId: this.userId,
                }, res => {
                    this.doCheck(res, res => {
                        let result = res.contents;
                        this.formModel = result;
                        this.formModel.status = this.formModel.status ? this.formModel.status.toString(): '0';

                        this.$refs.formModel.handleValid();
                    });
                }, '信息获取失败')
            },
            addLevelItem() {
                this.formModel.tatMemRewards.push({
                    stairIndex: this.formModel.tatMemRewards.length,
                    startIndex: 0,
                    endIndex: 0,
                    rewardsAmount: 0,
                });
            },
            removeLevelItem(item) {
                this.showConfirm('确定要删除此层级吗？').then(() => {
                    let index = this.formModel.tatMemRewards.indexOf(item);
                    if (index !== -1) {
                        this.formModel.tatMemRewards.splice(index, 1)
                    }
                }).catch(() => {
                });
            },
            ...mapActions({
                isReloadPage: StorageService.Reload.page,
            })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/fragment/OrganManage/NewReward.vue